import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';

export const getTerminalAvailability = async (body) => {
    const res = await handlePostRequest(URI.terminal_availability, body, {
        toast: false,
        loading: false,
    });
    return res;
};

export const collectTerminalPayment = async (body) => {
    const res = await handlePostRequest(URI.terminal_collect, body, {
        toast: false,
        loading: false,
    });
    return res;
};

export const getTerminalPaymentStatus = async (reference) => {
    const res = await handleGetRequest(URI.terminal_status(reference), null, {
        toast: false,
        loading: false,
    });
    return res;
};

export const cancelTerminalPayment = async (body) => {
    const res = await handlePostRequest(URI.terminal_cancel, body, {
        toast: false,
        loading: false,
    });
    return res;
};

export const collectCashPayment = async (body) => {
    const res = await handlePostRequest(URI.cash_collect, body, {
        toast: false,
        loading: false,
    });
    return res;
};

export const getPaymentTerminals = async () => {
    const res = await handleGetRequest(URI.payment_terminals, null, { loading: false });
    return res;
};

export const addPaymentTerminal = async (body) => {
    const res = await handlePostRequest(URI.payment_terminal, body);
    return res;
};

export const updatePaymentTerminal = async (body) => {
    const res = await handlePutRequest(URI.payment_terminal, body);
    return res;
};

export const deletePaymentTerminal = async (body) => {
    const res = await handleDeleteRequest(URI.payment_terminal, body);
    return res;
};
